export {
  type AppGraphemeMeaningCardDescription,
  appGraphemeMeaningCardDescriptionTable,
} from "#app-grapheme-meaning-card-description-table";
